import * as React from 'react';
import {
  Avatar,
  IconButton,
  ListItemText,
  Menu,
  MenuItem,
  useTheme,
} from '@mineral/core';
import { useOktaAuth } from '@okta/okta-react';
import { useEffect } from 'react';

// Based on https://material-ui.com/components/menus/#simple-menu
export const UserMenu: React.FC = () => {
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
  const [userName, setUserName] = React.useState<string>('');
  const [familyName, setFamilyName] = React.useState<string>('');
  const menuId = 'user-menu';

  const oktaAuthDetails = useOktaAuth();

  useEffect(() => {
    oktaAuthDetails?.oktaAuth
      .getUser()
      .then((data) => {
        setUserName(`${data.given_name}` || '');
        setFamilyName(`${data.family_name}` || '');
      })
      .catch(() => {
        setUserName('');
        setFamilyName('');
      });
  }, [oktaAuthDetails?.oktaAuth]);

  const handleLogout = () => {
    void oktaAuthDetails.oktaAuth.signOut();
  };

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleUserNameMenuItem = () => {
    if (userName) {
      return (
        <MenuItem
          disabled
          sx={{
            borderBottomColor: 'divider',
            borderBottomWidth: 1,
            borderBottomStyle: 'solid',
          }}>
          <ListItemText
            sx={{
              cursor: 'text',
              pointerEvents: 'auto',
              userSelect: 'text',
            }}
            primary={userName}
          />
        </MenuItem>
      );
    }
  };

  return (
    <>
      <IconButton
        aria-haspopup
        aria-label="user menu"
        onClick={handleClick}
        size="small">
        <Avatar
          sx={{ color: 'common.white', bgcolor: 'secondary.dark' }}
          size="medium">
          {userName && familyName
            ? userName[0] + familyName[0]
            : userName
            ? userName[0]
            : ''}
        </Avatar>
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{
          vertical: parseInt(theme.sizing.menuOffset),
          horizontal: 'right',
        }}
        PaperProps={{
          style: {
            minWidth: 200,
          },
        }}
        id={menuId}
        onClose={handleClose}
        open={Boolean(anchorEl)}
        variant="menu">
        {handleUserNameMenuItem()}
        <MenuItem onClick={handleClose} disabled>
          <ListItemText primary="Profile" />
        </MenuItem>
        <MenuItem onClick={handleLogout}>
          <ListItemText primary="Logout" />
        </MenuItem>
      </Menu>
    </>
  );
};
